<template>
  <div>
    <div class="edit-police pt-0">
      <div class="row justify-content-center">
        <div class="col-12">
          <div class="edit-police__head">
            <div class="edit-police__head__title">
              <span>Editar P&oacute;liza</span>
            </div>
          </div>
          <div class="edit-police__body">
            <div class="row">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-5">
                    <div class="form-group" :class="{ invalid: this.v$.policy.policyNumber.$error }">
                      <input type="text" class="form-control" v-model="this.v$.policy.policyNumber.$model" />
                      <label for="" class="d-none">Numero de poliza</label>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="form-group">
                      <button style="width: 100%" type="button" @click="searchPolicy()" :disabled="flags.searching">
                        <span v-if="!flags.searching">Buscar</span>
                        <i class="fas fa-circle-notch fa-spin" v-if="flags.searching"></i>
                      </button>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <div>
                        <div v-if="this.policy.entityStatus !== 0 && !flags.searching">
                          <button style="width: 100%" type="button" @click="reprocessPayments()">
                            <span v-if="!flags.deleting">Reprocesar Pagos</span>
                            <i class="fas fa-circle-notch fa-spin" v-if="flags.deleting"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="row">
                  <div class="col-4">
                    <div class="form-group">
                      <div v-if="this.policy.entityStatus !== 0 && !flags.searching">
                        <button style="width: 100%" type="button" @click="openPolicyModal()">
                          <span v-if="!flags.deleting">Enviar Póliza</span>
                          <i class="fas fa-circle-notch fa-spin" v-if="flags.deleting"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-3 edit-police__body__cancel">
                    <div>
                      <div v-if="this.policy.entityStatus !== 0 && !flags.searching">
                        <button style="width: 100%" type="button" @click="openCancelConfirmModal()">
                          <span v-if="!flags.deleting">Anular</span>
                          <i class="fas fa-circle-notch fa-spin" v-if="flags.deleting"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="row">
              <div class="col-md-12">
                <div v-if="flags.showPolicyData">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="edit-police__body__box">
                        <span class="edit-police__body__box__space"></span>
                        <h4>Estado de la p&oacute;liza</h4>
                        <div class="row mb-2">
                          <template v-if="this.policy.entityStatus === 0">
                            <div class="col-3">
                              <b class="text-danger">Anulada</b>
                            </div>
                          </template>
                          <template v-if="this.policy.entityStatus !== 0">
                            <div class="col-3">
                              <span class="police-state">{{
                                freezed ? "Congelada" : "Activa"
                              }}</span>
                              <!--span v-if="freezed">({{ freezingTime }} meses)</span-->
                            </div>
                            <div class="col-4">
                              <button type="button" v-if="freezed" @click="unfreezePolicy()" :disabled="flags.unfreezing">
                                <span v-if="!flags.unfreezing">Descongelar p&oacute;liza</span>
                                <i class="fas fa-circle-notch fa-spin" v-if="flags.unfreezing"></i>
                              </button>
                              <button type="button" v-if="!freezed" @click="openFreezeModal()"
                                :disabled="flags.unfreezing">
                                <span v-if="!flags.unfreezing">Congelar p&oacute;liza</span>
                                <i class="fas fa-circle-notch fa-spin" v-if="flags.unfreezing"></i>
                              </button>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="edit-police__body__box">
                        <span class="edit-police__body__box__space"></span>
                        <h4 class="text-main mt-2 mb-2">
                          D&eacute;bito autom&aacute;tico
                        </h4>
                        <div class="row mb-2">
                          <div class="col-3">
                            <span>{{
                              this.policy.debitAutomatic ? "Si" : "No"
                            }}</span>
                          </div>
                          <div class="col-4" v-if="isSuperAdmin">
                            <!-- <button class="btn btn-main" type="button" v-if="this.policy.debitAutomatic"
                              @click="openDesaffiliateConfirmModal()" :disabled="this.flags.disaffiliating">
                              <span v-if="!this.flags.disaffiliating">Desafiliar</span>
                              <i class="fas fa-circle-notch fa-spin" v-if="this.flags.disaffiliating"></i>
                            </button> -->
                            <button class="btn btn-main" type="button" v-if="!this.policy.debitAutomatic"
                              @click="openAffiliateConfirmModal()" :disabled="this.flags.disaffiliating">
                              <span v-if="!this.flags.disaffiliating">Afiliar</span>
                              <i class="fas fa-circle-notch fa-spin" v-if="this.flags.disaffiliating"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="edit-police__body__box">
                        <span class="edit-police__body__box__space"></span>
                        <h4 class="text-main mt-2 mb-2">
                          Informaci&oacute;n de la p&oacute;liza
                        </h4>
                        <div class="row">
                          <div class="col-10">
                            <div class="form-group" :class="{
                              invalid: this.v$.policy.paymentAmount.$error,
                            }">
                              <label for="">Importe mensual</label>
                              <input type="text" class="form-control" v-model="this.v$.policy.paymentAmount.$model" />
                            </div>
                            <div class="form-group" :class="{ invalid: this.v$.policy.expiresOn.$error }">
                              <!-- <input type="text" class="form-control" /> -->
                              <label for="" style="position: relative">Fecha de fin de plan</label>
                              <datepicker :id="'expiresOn'" v-model="this.v$.policy.expiresOn.$model"
                                v-bind:input-class="'form-control'" v-bind:format="'dd/MM/yyyy'" :language="es">
                              </datepicker>
                              <small>Por favor ingresa tu fecha de nacimiento</small>
                            </div>
                            <div class="form-group mt-2 text-right mb-2">
                              <button type="button" @click="save()" :disabled="flags.editing"
                                v-if="this.policy.entityStatus !== 0">
                                <span v-if="!flags.editing">Guardar cambios</span>
                                <i class="fas fa-circle-notch fa-spin" v-if="flags.editing"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="edit-police__body__box">
                        <span class="edit-police__body__box__space"></span>
                        <h4 class="text-main mt-2 mb-2">
                          Informaci&oacute;n del Cliente
                        </h4>
                        <div class="row">
                          <div class="col-10">
                            <div class="form-group">
                              <label class="title" for="">N&uacute;mero de documento</label>
                              <div class="edit-police__body__box__input-email">
                                <div class="input-group mb-3">
                                  <input type="text" class="form-control" placeholder="Documento" aria-label="Username"
                                    :value="user.identificationNumber" readonly aria-describedby="basic-addon1" />
                                </div>
                              </div>
                            </div>
                            <div class="form-group">
                              <label class="title" for="">Correo Electronico</label>
                              <div class="edit-police__body__box__input-email">
                                <div class="input-group mb-3" :class="{
                                  invalid: this.v$.user.email.$error,
                                }">
                                  <input type="text" class="form-control" placeholder="Email" aria-label="Username"
                                    v-model="user.email" aria-describedby="basic-addon1" />
                                </div>
                              </div>
                            </div>
                            <div class="form-group mt-2 text-right mb-2 d-flex justify-content-end">
                              <button type="button" @click="saveUser()" :disabled="flags.editingUser"
                                v-if="this.policy.entityStatus !== 0">
                                <span v-if="!flags.editingUser">Guardar cambios</span>
                                <i class="fas fa-circle-notch fa-spin" v-if="flags.editingUser"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="edit-police__body__box" v-if="flags.showPolicyData">
              <span class="edit-police__body__box__space"></span>
              <h4 class="mt-2 mb-2">Importes mensuales</h4>
              <table class="table table-hover table-striped">
                <thead>
                  <tr>
                    <th>N</th>
                    <th>Tipo</th>
                    <th>Fecha de vencimiento</th>
                    <th>Fecha de pago</th>
                    <th>Importe</th>
                    <th>C&oacute;digo de pago</th>
                    <th>Estado</th>
                    <th v-if="isSuperAdmin"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in payments" v-bind:key="item.paymentId">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.quote > 0 ? "Prima" : "Aporte adicional" }}</td>
                    <td>{{ item.dueDate }}</td>
                    <td>{{ formatDate(item.updatedOn) }}</td>
                    <td>S/{{ item.amount }}</td>
                    <td>{{ item.transactionExternalId }}</td>
                    <td>
                      <span class="badge badge-success" v-if="item.paymentStatus === 1">Pagado</span>
                      <span class="badge badge-danger" v-if="item.paymentStatus === 2">Pendiente</span>
                      <span class="badge badge-info" v-if="item.paymentStatus === 3">Congelado</span>
                      <span class="badge badge-danger" v-if="item.paymentStatus === 4">Pendiente sin DA</span>
                      <span class="badge badge-warning" v-if="item.paymentStatus === 5">Devuelta</span>
                      <span class="badge badge-info" v-if="policy.freeInstallment &&
                        item.quote === policy.freeInstallment
                        ">Prima devuelta</span>
                    </td>
                    <td v-if="isSuperAdmin">
                      <a role="button" v-if="item.paymentStatus === 2 &&
                        this.policy.entityStatus !== 0
                        " title="Marcar como pagada" class="text-main" @click="openRegisterPaymentModal(item)">
                        <i class="fas fa-file-invoice-dollar"></i>
                        &nbsp; Registrar pago
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="quote__step mt-0">
            <template>
              <form action="">
                <div class="row">
                  <div class="col-12">
                    <template v-if="flags.showPolicyData">
                      <hr />
                    </template>
                  </div>
                </div>
              </form>
            </template>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-success" ok-only ok-title="Entiendo" centered size="sm" modal-class="modal-blue" ref="modal-success">
      <div class="modal-blue__head pt-2">
        <i class="fas fa-check-circle fa-3x"></i>
        <h3>&Eacute;xito</h3>
      </div>
      <div class="modal-blue__head">
        <p>La p&oacute;liza fue actualizada correctamente.</p>
      </div>
    </b-modal>

    <b-modal id="modal-user-success" ok-only ok-title="Entiendo" centered size="sm" modal-class="modal-blue"
      ref="modal-user-success">
      <div class="modal-blue__head pt-2">
        <i class="fas fa-check-circle fa-3x"></i>
        <h3>&Eacute;xito</h3>
      </div>
      <div class="modal-blue__head">
        <p>El correo del usuario fue actualizado correctamente.</p>
      </div>
    </b-modal>

    <b-modal id="modal-confirm" ok-only ok-title="Esta seguro de anular la poliza?" centered size="l"
      modal-class="modal-blue" ref="modal-confirm">
      <div class="modal-error__header">
        <div class="modal-error__header__message">
          <span>Devoluci&oacute;n de Primas</span>
        </div>
      </div>
      <div class="modal-blue__head">
        <p class="mt-3 info">
          ¿Deseas devolver las primas pagadas del usuario?
        </p>
        <div class="content-btn d-flex justify-content-between mt-2 mb-2">
          <!-- <button class="btn btn-primary" type="button" @click="cancel()" :disabled="flags.deleting">
            <span v-if="!flags.deleting">Sí</span>
            <span v-if="flags.deleting">Anulando p&oacute;liza...</span>
          </button> -->
          <button class="btn btn-primary" style="color: #fff; ba"
            @click="openPolizasPagadasModal('modal-polizas-pagadas')">
            Sí
          </button>
          <button class="btn btn-default" style="color: #fff" @click="closeModal('modal-confirm')">
            No
          </button>
        </div>
      </div>
    </b-modal>
    <!-- MODAL DEL MODAL -->
    <b-modal id="modal-polizasPagadas" ok-only ok-title="Listado de polizas pagadas" centered size="lg"
      modal-class="modal-polizasPagadas" ref="modal-polizas-pagadas">
      <div class="modal-error__header">
        <div class="modal-error__header__message">
          <span>Anulación y Devolución</span>
        </div>
      </div>
      <div class="modal-blue__head">
        <!-- <p class="mt-3 info">¿Deseas devolver las primas pagadas del usuario?</p> -->
        <table class="table table-hover table-striped mt-3">
          <thead>
            <tr>
              <th>
                <div class="form-check m-auto" style="width: 25px">
                  <input class="form-check-input" type="checkbox" :id="'payments'" style="cursor: pointer"
                    :checked="paymentIds.length === polizasPagadas.length" @change="selectAllPayedPolicies()" />
                  <label class="form-check-label" :for="'payments'"> </label>
                </div>
              </th>
              <th>Tipo</th>
              <th>Fecha de vencimiento</th>
              <th>Fecha de pago</th>
              <th>Importe</th>
              <th></th>
            </tr>
          </thead>
          <tbody v-if="polizasPagadas.length > 0">
            <tr v-for="(item, index) in polizasPagadas" v-bind:key="item.paymentId">
              <td>
                <div class="form-check m-auto" style="width: 25px">
                  <input class="form-check-input" type="checkbox" :value="item.paymentId"
                    :id="'payment-' + item.paymentId" v-model="paymentIds" style="cursor: pointer" />
                  <label class="form-check-label" :for="'payment-' + item.paymentId">
                  </label>
                </div>
              </td>
              <td>{{ item.quote > 0 ? "Prima" : "Aporte adicional" }}</td>
              <td>{{ item.dueDate }}</td>
              <td>{{ formatDate(item.updatedOn) }}</td>
              <td>S/{{ item.amount }}</td>
            </tr>
          </tbody>
        </table>
        <div class="content-btn d-flex justify-content-between mt-2 mb-2">
          <button class="btn btn-primary" type="button" @click="cancel()" :disabled="flags.deleting">
            <span v-if="!flags.deleting">Anular</span>
            <span v-if="flags.deleting">Anulando p&oacute;liza...</span>
          </button>
          <button class="btn btn-default" style="color: #fff" @click="closeModal('modal-polizas-pagadas')">
            No
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal id="modal-confirm" ok-only ok-title="Esta seguro de desafiliar la poliza?" centered size="sm"
      modal-class="modal-blue" ref="modal-confirm-desaffiliate">
      <div class="modal-blue__head pt-2">
        <i class="fas fa-timex fa-3x text-danger"></i>
        <h3>Desafiliar P&oacute;liza</h3>
      </div>
      <div class="modal-blue__head">
        <p>
          ¿Esta seguro de desafiliar la póliza
          {{ this.policy.policyNumber }} del débito automático?
        </p>
        <div class="d-flex justify-content-between">
          <button class="btn btn-default" style="color: #fff" @click="closeModal('modal-confirm-desaffiliate')">
            Cerrar
          </button>
          <button class="btn btn-danger" type="button" @click="desaffiliate()" :disabled="this.flags.disaffiliating">
            <span v-if="!this.flags.disaffiliating">Desafiliar</span>
            <span v-if="this.flags.disaffiliating">Desafiliando p&oacute;liza...</span>
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal id="modal-confirm" ok-only ok-title="Esta seguro de desafiliar la poliza?" centered size="sm"
      modal-class="modal-blue" ref="modal-confirm-affiliate">
      <div class="modal-blue__head pt-2">
        <i class="fas fa-timex fa-3x text-danger"></i>
        <h3>Afiliar P&oacute;liza</h3>
      </div>
      <div class="modal-blue__head">
        <p>
          ¿Esta seguro de afiliar la póliza
          {{ this.policy.policyNumber }} al débito automático?
        </p>
        <div class="d-flex justify-content-between">
          <button class="btn btn-default" style="color: #fff" @click="closeModal('modal-confirm-affiliate')">
            Cerrar
          </button>
          <button class="btn btn-danger" type="button" @click="affiliate()" :disabled="this.flags.affiliating">
            <span v-if="!this.flags.affiliating">Afiliar</span>
            <span v-if="this.flags.affiliating">Afiliando p&oacute;liza...</span>
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal id="modal-error" ok-only ok-title="Entiendo" centered size="md" modal-class="modal-blue" ref="modal-error">
      <div class="modal-blue__head">
        <img :src="require('@/assets/images/app/alert.svg')" alt="" />
        <h3>Ups!</h3>
      </div>
      <div class="modal-blue__head">
        <p>
          {{ errors.message }}
        </p>
      </div>
    </b-modal>

    <b-modal id="modal-register-payment" ok-only ok-title="Entendido" centered size="sm" modal-class="modal-login"
      title="Registrar pago" ref="modal-register-payment">
      <form class="modal-login__form">
        <div class="form-group" :class="{
          invalid: this.v$.payment.transactionId.$error,
        }">
          <input type="text" class="form-control" placeholder="Id de transacci&oacute;n de Culqi"
            v-model="this.v$.payment.transactionId.$model" />
          <small>Id de transacci&oacute;n</small>
        </div>
        <div class="form-group mt-3">
          <button class="btn btn-pink" @click="registerPayment()" type="button" :disabled="flags.registeringPayment">
            <span v-if="!flags.registeringPayment">Guardar</span>
            <i class="fas fa-circle-notch fa-spin" v-if="flags.registeringPayment"></i>
          </button>
        </div>
      </form>
    </b-modal>

    <b-modal id="modal-freeze" ok-only ok-title="Entendido" centered size="sm" modal-class="modal-login"
      title="Registrar pago" ref="modal-freeze">
      <form class="modal-login__form">
        <div class="form-group" :class="{
          invalid: this.v$.payment.transactionId.$error,
        }">
          <select name="" id="" style="-webkit-appearance: auto; text-align: left" v-model="v$.freeze.months.$model"
            class="form-control">
            <option value="">Selecciona el numero de meses</option>
            <option value="1">1 Mes</option>
            <option value="2">2 Meses</option>
          </select>
          <small>Selecciona el n&uacute;mero de meses a congelar</small>
        </div>
        <div class="form-group mt-3">
          <button class="btn btn-pink" @click="freezePolicy()" type="button" :disabled="flags.unfreezing">
            <span v-if="!flags.unfreezing">Congelar p&oacute;liza</span>
            <i class="fas fa-circle-notch fa-spin" v-if="flags.unfreezing"></i>
          </button>
        </div>
      </form>
    </b-modal>
    <b-modal id="modal-policy" ok-only ok-title="Entendido" centered size="sm" modal-class="modal-login"
      title="Enviar póliza" ref="modal-policy">
      <form class="modal-login__form">
        <div class="form-group" :class="{
          invalid: this.v$.policy.email.$error,
        }">
          <input type="text" class="form-control" placeholder="Ingrese Email" v-model="this.v$.policy.email.$model" />
          <small>Ingrese un email v&aacute;lido</small>
        </div>
        <div class="form-group mt-3">
          <button class="btn btn-pink" @click="sendPolicy()" type="button" :disabled="flags.sendingPolicy">
            <span v-if="!flags.sendingPolicy">Enviar póliza</span>
            <i class="fas fa-circle-notch fa-spin" v-if="flags.sendingPolicy"></i>
          </button>
        </div>
        <p v-if="this.flags.sendedPolicy" class="mt-2 text-success text-center">
          Póliza enviada, por favor revisa tu correo.
        </p>
        <p v-if="this.flags.sendedPolicyError" class="mt-2 text-danger text-center">
          Ocurrió un error al enviar la póliza, vuelve a intentar en unos segundos
        </p>
      </form>
    </b-modal>
  </div>
</template>
  
<script lang="ts">
import { BButton, BModal, VBModal, BCardText } from "bootstrap-vue";
import Datepicker from "vuejs-datepicker";
import Vuelidate from "vuelidate";
import es from "vuejs-datepicker/dist/locale/translations/es";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
import {
  required,
  minLength,
  maxLength,
  email,
  numeric,
  sameAs,
  requiredIf,
} from "vuelidate/lib/validators";
import axios from "axios";
import valid from "card-validator";
import moment from "moment";
import { init } from "echarts/lib/echarts";
import { environment } from "../../../environment/environment";
import { defineComponent } from "vue";
import useVuelidate from "@vuelidate/core";

export default defineComponent({
  components: {
    Datepicker,
    BCardText,
    VueSlider,
    BModal,
  },
  data() {
    return {
      apiUrl: environment.api,
      isApiNewBack: environment.isApi,
      isApiCancel: environment.isApiCancel,
      v$: useVuelidate(),
      policy: {
        policyId: "",
        policyNumber: "",
        operationType: "1",
        paymentAmount: null,
        expiresOn: null,
        freeInstallment: null,
        email: "",
      },
      payment: {
        transactionId: "",
      },
      freeze: {
        months: "",
      },
      flags: {
        editing: false,
        editingUser: false,
        searching: false,
        showPolicyData: false,
        registeringPayment: false,
        unfreezing: false,
        deleting: false,
        affiliating: false,
        sendingPolicy: false,
        sendedPolicy: false,
        sendedPolicyError: false,
      },
      user: {
        userId: "",
        email: "",
        identificationNumber: "",
      },
      es: es,
      errors: {
        message: "",
      },
      payments: [],
      freezed: false,
      freezingTime: 0,
      selectedPayment: null,
      polizasPagadas: [],
      paymentIds: [],
      isSuperAdmin: false,
      consTrack: {
        AplicacionEndoso: "A",
        SolicitudEndoso: "S",
        AdminRumbo: "ADM",
        ZonaCliente: "CLI",
        EndosoSimple: "ED",
        EndosoComplejo: "EC",
      },
      paymentAmountLast: 0,
    };
  },
  validations: function () {
    return {
      policy: {
        policyId: { required },
        policyNumber: { required },
        operationType: {},
        paymentAmount: {},
        expiresOn: { required },
        email: { required },
      },
      payment: {
        transactionId: { required },
      },
      freeze: {
        months: { required },
      },
      user: {
        userId: {},
        email: { required, email },
      },
    };
  },
  created() {
    this.init();
  },
  watch: {},
  methods: {
    init() {
      this.getUser();

      if (
        this.$route.query &&
        this.$route.query.policyNumber &&
        this.$route.query.policyNumber !== ""
      ) {
        this.policy.policyNumber = this.$route.query.policyNumber;
        this.searchPolicy();
      }
    },
    getUser() {
      let user: any = JSON.parse(localStorage.getItem("__user__"));
      this.user = user;

      this.userRole = user.roles[0];

      if (user.roles && user.roles.length > 0 && user.roles[0] === "Admin") {
        this.isSuperAdmin = true;
      }
    },
    async searchPolicy() {
      if (this.policy.policyNumber === "") {
        return;
      }

      this.flags.searching = true;

      let auth = JSON.parse(window.localStorage.getItem("__auth__"));
      let headers = {
        headers: {
          Authorization: auth.token_type + " " + auth.access_token,
        },
      };

      var result = await axios.get(
        `${this.apiUrl}policies/search?q=0${this.policy.policyNumber}`,
        headers
      );

      try {
        if (result.data) {
          let data = result.data;

          // this.policy = data;

          // this.policyNumber = data.referencePolicyNumber;
          this.policy.policyId = data.policyId;
          this.policy.expiresOn = data.expiresOn;
          this.policy.paymentAmount = data.paymentAmount;
          this.policy.entityStatus = data.entityStatus;
          this.policy.debitAutomatic = data.debitAutomatic;
          this.policy.freeInstallment = data.freeInstallment;
          this.policy.email = data.user.email; //conirmar

          this.paymentAmountLast = data.paymentAmount;

          this.freezed = data.freezed;

          this.payments = data.payments.map((el) => {
            if (el.quote > 1) {
              el.dueDate = moment(el.transactionDate)
                .add(1, "months")
                .format("[01]/MM/YYYY");
            }

            if (el.quote <= 1) {
              el.updatedOn = el.transactionDate;
              el.dueDate = moment(el.transactionDate).format("DD/MM/YYYY");
            }

            return el;
          });

          this.polizasPagadas = this.payments.filter(
            (payment) => payment.paymentStatus === 1
          );

          if (this.freezed) {
            let paidInstallments = this.payments.filter(
              (el) => el.paymentStatus === 1
            );
            let pendingInstallments = this.payments.filter(
              (el) => el.paymentStatus === 2
            );
            let lastPaidInstallment =
              paidInstallments[paidInstallments.length - 1];
            let firstPendingInstallment = pendingInstallments[0];
            let freezingTime = moment(
              firstPendingInstallment.transactionDate
            ).diff(moment(lastPaidInstallment.transactionDate), "months");

            this.freezingTime = freezingTime;
          }

          this.user.userId = data.userId;
          this.user.email = data.user.email;
          this.user.identificationNumber = data.user.identificationNumber;
          this.flags.showPolicyData = true;
        }
      } catch (error) { }

      this.flags.searching = false;
    },
    async reprocessPayments() {
      let url = `${this.apiUrl}policies/sync-payments`;
      let auth = JSON.parse(window.localStorage.getItem("__auth__"));
      let headers = {
        headers: {
          Authorization: auth.token_type + " " + auth.access_token,
        },
      };
      let model = {
        policyNumber: '0' + this.policy.policyNumber
      };
      let result = await axios.post(url, model, headers);
      try {
        if (result.data) {
          this.searchPolicy();
        }
      } catch (error) {
        console.log(error);
      }

    },
    openRegisterPaymentModal(payment) {
      this.selectedPayment = payment;
      this.$refs["modal-register-payment"].show();
    },
    openFreezeModal() {
      this.$refs["modal-freeze"].show();
    },
    async unfreezePolicy() {
      let url = `${this.apiUrl}policies/${this.policy.policyId}/unfreeze`;
      this.flags.unfreezing = true;
      let model = {
        policyId: this.policy.policyId,
        transactionExternalId: this.payment.transactionId,
      };
      let auth = JSON.parse(window.localStorage.getItem("__auth__"));
      let headers = {
        headers: {
          Authorization: auth.token_type + " " + auth.access_token,
        },
      };

      try {
        let result = await axios.put(url, model, headers);
        if (result.data !== undefined) {
          this.flags.unfreezing = false;
          this.searchPolicy();
        }
      } catch (error) {
        this.flags.unfreezing = false;
      }
    },
    async freezePolicy() {
      let url = `${this.apiUrl}policies/${this.policy.policyId}/freeze-admin`;
      this.flags.unfreezing = true;
      let meses = this.freeze.months;
      let expiracion= this.policy.expiresOn;
      let model = {
        policyId: this.policy.policyId,
        months: parseInt(meses),
      };
      let auth = JSON.parse(window.localStorage.getItem("__auth__"));
      let headers = {
        headers: {
          Authorization: auth.token_type + " " + auth.access_token,
        },
      };
      console.log("Fecha de fin de plan", expiracion)
      console.log("Meses congelados", meses)
      try {
        let result = await axios.post(url, model, headers);
        if (result.data !== undefined) {
          this.trackingReport(this.consTrack.AplicacionEndoso, this.consTrack.AdminRumbo, this.consTrack.EndosoSimple, "Congelamiento/Diferimiento", "", "", meses, expiracion, "")
          this.flags.unfreezing = false;
          await this.$refs["modal-freeze"].hide();
          this.searchPolicy();
        }
      } catch (error) {
        this.flags.unfreezing = false;
      }
    },
    async registerPayment() {
      if (this.v$.payment.$invalid) {
        this.v$.payment.$touch();
        return;
      }
      this.flags.registeringPayment = true;

      let url = `${this.apiUrl}policies/${this.policy.policyId}/pay/${this.selectedPayment.paymentId}`;

      let model = {
        policyId: this.policy.policyId,
        transactionExternalId: this.payment.transactionId,
      };
      let auth = JSON.parse(window.localStorage.getItem("__auth__"));
      let headers = {
        headers: {
          Authorization: auth.token_type + " " + auth.access_token,
        },
      };

      try {
        let result = await axios.put(url, model, headers);
        if (result.data !== undefined) {
          this.payment.transactionId = "";
          this.searchPolicy();
          await this.$refs["modal-register-payment"].hide();
          this.flags.registeringPayment = false;
        }
      } catch (error) {
        this.errors.message = error.response.data.detail;
        this.$refs["modal-error"].show();
        this.flags.registeringPayment = false;
      }
    },
    async save() {
      if (this.v$.policy.$invalid) {
        this.v$.policy.$touch();
        return;
      }
      this.flags.editing = true;

      let url = `${this.apiUrl}policies/${this.policy.policyId}/`;
      let montoPago = this.policy.paymentAmount;
      let model = {
        policyId: this.policy.policyId,
        paymentAmount: parseFloat(montoPago),
        expiresOn: this.policy.expiresOn,
      };
      let auth = JSON.parse(window.localStorage.getItem("__auth__"));
      let headers = {
        headers: {
          Authorization: auth.token_type + " " + auth.access_token,
        },
      };

    
      // Registrar datos en reporte tracking

      try {
        let result = await axios.put(url, model, headers);
        if (result.data !== undefined) {
          if (this.paymentAmountLast > this.policy.paymentAmount) {
            this.trackingReport(this.consTrack.AplicacionEndoso, this.consTrack.AdminRumbo, this.consTrack.EndosoComplejo, "Disminución de prima", montoPago, "", "", "")
          } else if (this.paymentAmountLast < this.policy.paymentAmount) {
            this.trackingReport(this.consTrack.AplicacionEndoso, this.consTrack.AdminRumbo, this.consTrack.EndosoComplejo, "Incremento de prima", montoPago, "", "", "")
          }
          this.flags.editing = false;
          this.$refs["modal-success"].show();

          this.searchPolicy();
        }
      } catch (error) {
        this.errors.message = error.response.data.detail;
        this.$refs["modal-error"].show();
        this.flags.editing = false;
      }
    },
    async saveUser() {
      if (this.v$.user.$invalid) {
        this.v$.user.$touch();
        return;
      }
      this.flags.editingUser = true;

      let url = `${this.apiUrl}users/email`;
      let emailActual = this.user.email;
      console.log("emailActual",emailActual)
      let model = {
        userId: this.user.userId,
        email: emailActual,
      };
      let auth = JSON.parse(window.localStorage.getItem("__auth__"));
      let headers = {
        headers: {
          Authorization: auth.token_type + " " + auth.access_token,
        },
      };
     
      try {
        let result = await axios.put(url, model, headers);
        if (result.data !== undefined) {
          // Registrar datos en reporte tracking
          this.trackingReport(this.consTrack.AplicacionEndoso, this.consTrack.AdminRumbo, this.consTrack.EndosoSimple, "Actualización de correo", "", "", "", emailActual)

          this.flags.editingUser = false;
          this.$refs["modal-user-success"].show();

          this.searchPolicy();
        }
      } catch (error) {
        this.errors.message = error.response.data.detail;
        this.$refs["modal-error"].show();
        this.flags.editingUser = false;
      }
    },
    formatDate(date) {
      if (!date) return "";

      return moment(date).format("DD/MM/YYYY");
    },
    async cancel() {
      this.flags.deleting = true;

      let url = `${this.apiUrl}policies/${this.policy.policyId}/delete`;

      let auth = JSON.parse(window.localStorage.getItem("__auth__"));

      let headers = {
        headers: {
          Authorization: auth.token_type + " " + auth.access_token,
        },
        data: {
          paymentIds: this.paymentIds,
        },
      };
      try {
        let result = await axios.delete(url, headers);
        if (result.data !== undefined) {
          this.cancelRumboBD()
          this.searchPolicy();
        }

        this.flags.deleting = false;
        this.$refs["modal-polizas-pagadas"].hide();
      } catch (error) {
        this.errors.message = error.response.data.detail.substring(0, 150) + "...";
        this.$refs["modal-error"].show();
        this.flags.deleting = false;
      }
    },
    async cancelRumboBD() {

      //método para anular póliza en la nueva bd de rumbo.
      let model = {
        numeroPoliza: '0' + this.policy.policyNumber
      };
      var result = await axios.post(`${this.isApiCancel}`, model);
    },
    async desaffiliate() {
      this.flags.disaffiliating = true;

      let url = `${this.apiUrl}policies/${this.policy.policyId}/disable-automatic-debit`;

      let auth = JSON.parse(window.localStorage.getItem("__auth__"));

      let headers = {
        headers: {
          Authorization: auth.token_type + " " + auth.access_token,
        },
      };

      try {
        let result = await axios.put(url, {}, headers);
        if (result.data !== undefined) {
          this.searchPolicy();
        }

        this.flags.disaffiliating = false;
        this.$refs["modal-confirm-desaffiliate"].hide();
      } catch (error) {
        this.flags.disaffiliating = false;
      }
    },
    async affiliate() {
      this.flags.affiliating = true;

      let url = `${this.apiUrl}policies/${this.policy.policyId}/enable-automatic-debit`;

      let auth = JSON.parse(window.localStorage.getItem("__auth__"));

      let headers = {
        headers: {
          Authorization: auth.token_type + " " + auth.access_token,
        },
      };

      try {
        let result = await axios.put(url, {}, headers);
        if (result.data !== undefined) {
          this.searchPolicy();
        }

        this.flags.affiliating = false;
        this.$refs["modal-confirm-affiliate"].hide();
      } catch (error) {
        this.flags.affiliating = false;
      }
    },
    async trackingReport(operacion, canal, tipo, detalle, nueva_prima, monto_aporte_adicional, meses_congelados, fecha_congelamiento, nuevo_correo) {
      let url = `${this.isApiNewBack}v1/legacy/report/tracking`;
      let model = {
        operacion: operacion,
        canal: canal,
        tipo: tipo,
        detalle: detalle,
        numero_poliza: '0' + this.policy.policyNumber,
        nueva_prima: nueva_prima,
        monto_aporte_adicional: monto_aporte_adicional,
        meses_congelados: meses_congelados,
        fecha_congelamiento: fecha_congelamiento,
        nuevo_correo: nuevo_correo
      };

      try {
        let result = await axios.post(url, model);
        if (result.data !== undefined) {
          console.log(result.data)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async sendPolicy() {
      let _context = this;
      let url = `${this.isApiNewBack}v1/email/policy`;
      this.flags.sendingPolicy = true;
      let model = {
        numeroPoliza: '0' + this.policy.policyNumber,
        asegurado: {
          email: this.policy.email,
        }
      };
      console.log("model", model)

      try {
        let result = await axios.post(url, model);
        if (result.data !== undefined) {
          this.flags.sendingPolicy = false;
          this.flags.sendedPolicy = true;
        }
      } catch (error) {
        console.log(error)
        this.flags.sendingPolicy = false;
        this.flags.sendedPolicy = false;
        this.flags.sendedPolicyError = true;
      }

      setTimeout(() => {
        // _context.$refs["modal-policy"].hide();
        _context.flags.sendedPolicy = false;
        _context.policy.email = "";
        this.flags.sendedPolicy = false;
        this.flags.sendedPolicyError = false;
        this.v$.policy.$reset();
      }, 4000);
    },
    openCancelConfirmModal() {
      this.$refs["modal-polizas-pagadas"].show();
    },
    openAffiliateConfirmModal() {
      this.$refs["modal-confirm-affiliate"].show();
    },
    openDesaffiliateConfirmModal() {
      this.$refs["modal-confirm-desaffiliate"].show();
    },
    openPolizasPagadasModal(nombremodal) {
      this.$refs[nombremodal].show();
    },

    closeModal(modal) {
      this.$refs[modal].hide();
    },
    selectAllPayedPolicies() {
      if (this.paymentIds.length < this.polizasPagadas.length) {
        this.paymentIds = this.polizasPagadas.map((el) => el.paymentId);
      } else {
        this.paymentIds = [];
      }
    },
    openPolicyModal() {
      this.$refs["modal-policy"].show();
    },
  },
});
</script>
  
<style lang="scss">
/**/
@import "../../../styles/abstracts/variables";
/**/

.edit-police {
  background-color: #f4f6fc;

  &__head {
    margin: 0px 0px 15px 0px !important;

    &__title {
      font-weight: 500;
      font-size: 28px;
      color: #0855c4;
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: space-between;

    }
  }

  &__body {
    .row {
      .form-group {
        .form-control {
          height: 39px !important;
          font-size: 14px;
          border: 1px solid #c5c5c5;
          border-radius: 4px;
          border-width: 2px;

          &:focus {
            box-shadow: 0px 1px 8px rgba($color: #000000, $alpha: 0.1);
          }
        }

        button {
          padding: 8px 25px;
          font-weight: 500;
          border-radius: 5px;
          border: none;
          font-size: 14px;
          color: white;
          background-color: $primaryBlue;
        }
      }

    }

    &__cancel {
      button {
        padding: 8px 25px;
        font-weight: 500;
        border-radius: 5px;
        border: none;
        font-size: 14px;
        margin-right: 130px;
        color: white;
        //width: 250px !important;
        background-color: $primaryRed;
        transition: 0.3s;

        &:hover {
          box-shadow: 0px 8px 20px rgba($color: $primaryRed, $alpha: 0.5);
        }
      }
    }

    &__box {
      .title {
        color: #0855c4;
        font-size: 14px;
        margin: 0px 0px 5px 0px;
      }

      &__space {
        display: block;
        margin: 40px 0px 20px 0px;
        opacity: 0.2;
        width: 100%;
        height: 1px;
        background-color: $secondGray;
      }

      &__input-email {
        .form-control {
          height: 39px !important;
          font-size: 14px;
          border: 1px solid #c5c5c5;
          border-radius: 4px;
          border-width: 2px;
        }
      }

      h4 {
        font-weight: 500;
        font-size: 18px;
        color: $primaryBlue !important;
        display: flex;
        margin-bottom: 20px;
        width: 100%;
        align-items: center;
        justify-content: space-between;
      }

      .row {
        .col-3 {
          span {
            display: block;
            color: $primaryGray;
            display: block;
            font-size: 14px;
          }

          span:not(.police-state) {
            margin-top: 8px;
          }
        }

        .col-10 {
          .form-group {
            margin: 0px 0px 20px 0px;

            &:first-child {
              margin: 15px 0px 20px 0px;
            }

            label {
              color: $primaryBlue;
              font-size: 14px;
              margin: 0px 0px 5px 0px;
            }

            &:last-child {
              display: flex;
              justify-content: end;
            }
          }
        }

        .col-4 {
          display: flex;
          justify-content: end;

          button {
            padding: 8px 25px 8px 25px;
            font-weight: 500;
            border-radius: 5px;
            border: none;
            font-size: 14px;
            color: white;
            background-color: $primaryBlue;
          }
        }
      }

      .table {
        thead {
          tr {
            th {
              vertical-align: top;
              text-transform: uppercase;
              font-size: 12px;
              letter-spacing: 0.5px;
              color: $primaryGray;
              padding: 0.72rem 2rem;
              border-bottom: 2px solid #ebe9f1;
              background-color: #f3f2f7;
            }
          }
        }

        tbody {
          tr {
            background-color: white;

            td {
              font-size: 14px;
              color: $primaryGray;
              border: none;
              padding: 0.72rem 2rem;
              vertical-align: middle;
              border-top: 1px solid #ebe9f1;

              .badge {
                // display: flex;
                // justify-content: center;
                // align-items: center;
                line-height: 17px;
                font-size: 11px;
                height: 25px;
                width: fit-content;
                margin-right: 8px;
              }

              a {
                text-decoration: none;
                color: $primaryBlue !important;
              }

              .delete {
                display: flex;
                align-items: center;
                color: $primaryRed;
                background-color: transparent;
                border: none;

                span {
                  display: block;
                  padding-left: 10px;
                }
              }

              .badge-success {
                background-color: $green;
              }

              .badge-info {
                background-color: $info;
              }

              .badge-danger {
                background-color: $primaryRed;
              }

              .badge-warning {
                background-color: $warning;
              }
            }
          }

          tr:nth-child(even) {
            background-color: transparent;
          }
        }
      }

      .table> :not(caption)>*>* {
        box-shadow: none;
      }
    }
  }
}

// .edit-police {
//   .modal-blue {
//     .modal-dialog {
//       .modal-content {
//         background-color: #fff;

//         .modal-footer,
//         .modal-header {
//           display: block;
//         }
//       }
//     }

//     &__head {
//       color: #0855c4;
//       text-align: center;
//       font-weight: 500;

//       h3 {
//         font-weight: bolder;
//         color: $thirdColor;
//       }

//       i {
//         margin-bottom: 10px;
//         color: $thirdColor;
//       }

//       p {
//         a {
//           color: #fff;
//           text-decoration: underline;
//         }
//       }
//     }

//     &__body {
//       p {
//         font-size: 14px;
//         color: #fff;
//       }
//     }
//   }

// }

.moda-blue {
  .modal {
    .modal-dialog {
      .modal-content {
        .modal-body {
          padding-left: 0px;
          padding-right: 0px;
          background-color: #fff;
          padding-top: 0px;
          border-radius: 20px;
        }
      }
    }
  }
}

.invalid {
  input {
    border-color: $danger !important;
  }
}

@media (min-width: 576px) {
  .modal-sm {}
}
</style>
  